module.exports = __webpack_public_path__ + "src/img/artist/name05.svg?8946c0f2bc9b582bea3b9448579222d9";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/name05.svg
// module id = 141
// module chunks = 0